import { Howl } from "howler";
// 겹치면 안되는 사운드
window.__wordSound = null;
window.__bgmSound = null;
window.__bgmVolume = 0.5;
window.__effectVolume = 0.7;
window.__wordVolume = 1;

// 이펙트 사운드는 겹칠 수 있다.
const effect = (url) => {
  const effectSoundObj = new Howl({
    src: [url],
    html5: true,
    loop: false,
    volume: window.__effectVolume,
    autoplay: true,
    onend: () => {
      if (effectSoundObj) {
        effectSoundObj.stop();
        effectSoundObj.unload();
      }
    },
    onstop: () => {
      if (effectSoundObj) {
        effectSoundObj.stop();
        effectSoundObj.unload();
      }
    },
  });
};

const bgm = (url) => {
  if (window.__bgmSound) {
    window.__bgmSound.stop();
    window.__bgmSound.unload();
    window.__bgmSound = null;
  }

  if (url === null) {
    if (window.__bgmSound) {
      window.__bgmSound.stop();
      window.__bgmSound.unload();
      window.__bgmSound = null;
    }
    return;
  }

  window.__bgmSound = new Howl({
    src: [url],
    loop: true,
    html5: true,
    volume: window.__bgmVolume,
    autoplay: false,
  });

  window.__bgmSound.play();
  window.__bgmSound.fade(0, window.__bgmVolume, 1000);
};

const word = (url) => {
  return new Promise((res) => {
    if (window.__wordSound) {
      window.__wordSound.stop();
      window.__wordSound.unload();
      window.__wordSound = null;
    }
    if (url) {
      window.__wordSound = new Howl({
        src: [url],
        html5: true,
        volume: window.__wordVolume,
        loop: false,
        onend: function () {
          if (window.__wordSound) {
            window.__wordSound.stop();
            window.__wordSound.unload();
            window.__wordSound = null;
          }

          res();
        },
      });
      window.__wordSound.play();
    }
  });
};
const wordStop = () => {
  if (window.__wordSound) {
    window.__wordSound.stop();
    window.__wordSound.unload();
    window.__wordSound = null;
  }
};

const sound = {
  effect,
  word,
  bgm,
  wordStop,
};

export default sound;
